module.exports = __webpack_public_path__ + "static/media/switch.0b5c6c69.wav";


//////////////////
// WEBPACK FOOTER
// ./src/switch.wav
// module id = 113
// module chunks = 0